module.exports = __webpack_public_path__ + "static/media/partners_main_pc.e1ed3f1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/partners_main_pc.mp4
// module id = vL6S
// module chunks = 1